export default {"src":"/_next/static/image/public/images/ic_vector_left.cd1551f8010f6932953537ab501b763b.svg","height":36,"width":32};